import { color, spacing, typography } from '$tablet-app/src/app/theme';
import React, { useState } from 'react';
import { StyleSheet, TextInput, View } from 'react-native';
import { Text } from '../Text/Text';
import { TextInputProps } from '../TextInput/TextInput.props';

const TextInputMultilineGrow = (props: TextInputProps) => {
  const {
    preset = 'default',
    error,
    children,
    style: styleOverride,
    ...rest
  } = props;

  const [borderColor, setBorderColor] = useState<string>(
    preset === 'default' ? color.formElement : color.primaryIcon
  );
  const [height, setHeight] = useState<number>(56);

  const onBlur = () => setBorderColor(color.formElement);
  const onFocus = () => setBorderColor(color.primaryIcon);

  return (
    <>
      <View
        style={StyleSheet.flatten([
          styles.buttonContainer,
          styleOverride,
          { borderColor },
        ])}
      >
        <TextInput
          multiline
          numberOfLines={6}
          style={StyleSheet.flatten([styles.input, { height }])}
          {...rest}
          onBlur={onBlur}
          onFocus={onFocus}
          onContentSizeChange={(e) => {
            setHeight(Math.max(56, e.nativeEvent.contentSize.height));
          }}
        />
      </View>
      {error && <Text preset="error">{error.message}</Text>}
    </>
  );
};

// Styles
const styles = StyleSheet.create({
  buttonContainer: {
    borderColor: color.formElement,
    borderWidth: 2,
    borderRadius: 10,
  },
  input: {
    minWidth: 210,
    flex: 1,
    padding: spacing[4],
    color: color.text,
    fontFamily: typography.primary.regular,
    fontSize: 18,
    height: 'auto',
  },
});

export default TextInputMultilineGrow;
